export default __webpack_public_path__ + "static/media/Bandit's Leggings of the Grasping Wild.fdd52a10.jpg";